import Immutable from 'seamless-immutable';
import _ from 'lodash';
import DomainModel from './domain-model';
import { baseCollection } from '../../common/collections';

/**
 * Transforms and array of backend domain objects into a domainCollection
 * @typedef {Object} Response
 * @param {Object[]} content - backend formatted domains
 * @returns {Object} Containing domains{domain[]} and count{Number} properties
 */
function deserialize(content = []) {
  return Immutable(_.map(content, DomainModel.deserialize));
}

/**
 * Transforms a domainCollection into an array of backend domain objects
 * @param {domain[]} domains
 * @returns {Object[]}
 */
function serialize(domains) {
  return _.map(domains, domain => DomainModel.serialize(domain));
}

export default {
  ...baseCollection,
  create: deserialize,
  deserialize,
  serialize,
};
